<template>
  <div>Renewal</div>
</template>
<script type="text/javascript">
export default {
  name: 'Renewal',
  components: {}
}

</script>



// WEBPACK FOOTER //
// src/Homepage/components/Notification/components/Renewal.vue